import { render } from "./IconStackedLayers.vue?vue&type=template&id=23b5f3ac"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconStackedLayers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23b5f3ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23b5f3ac', __exports__)) {
    api.reload('23b5f3ac', __exports__)
  }
  
  module.hot.accept("./IconStackedLayers.vue?vue&type=template&id=23b5f3ac", () => {
    api.rerender('23b5f3ac', render)
  })

}


export default __exports__